import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';
import { Person } from '../../core-data-model/Person.model';
import { Logger } from '../../system-services/Logger/Logger.service';
import { TranslationService } from '../../translations/Translation.service';

@Component({
    selector: 'my-ba-profile',
    templateUrl: 'my-ba-profile.component.html',
    styleUrls: ['./my-ba-profile.less'],
    standalone: false
})
export class MyBaProfileComponent {
    @Input()
    showCoverView = false;

    @Input()
    person: Person;

    @Output()
    viewProfileClicked = new EventEmitter();

    insightsLoading = false;

    constructor(
        public TR: TranslationService,
        private cd: ChangeDetectorRef,
        private logger: Logger
    ) {}

    getReferencePatternDesc(person: Person) {
        return this.TR.key(person?.referencePattern?.tooltipKey);
    }

    viewYourProfileClicked(event) {
        event.stopPropagation();
        this.viewProfileClicked.emit();
        this.showCoverView = false;
        this.logger.logInfo(
            'MyBAProfile - BA experience profile unlocked/viewed',
            {
                userId: this.person.id,
                email: this.person.email
            }
        );
    }

    updateInsightsLoading(loading: boolean) {
        this.insightsLoading = loading;
        // Added detection because 'loading' can change asynchronously during the angular life cycle
        // this causes an ExpressionChangedAfterItHasBeenChecked error.  This prevents that.
        this.cd.detectChanges();
    }

}
